<cp-widget [errorList]="inputValueContract?.errorList" [isHideLoading]="isHideLoading" [idGraphic]="0" style="position: relative; width: auto;">

    <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6" style="width: fit-content; padding-left: 3.5em;">
      <cp-gauge class="cp-font-normal" [value]="percentage" [Kind]="kindInsumo" [startlegend]="startLegend" [endlegend]="endLegend"></cp-gauge>
    </div>
    <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-div-container">
      <div>
        <div>
          <p class="cp-info-labels">{{ startLegend }}</p>
        </div>
        <div class="po-row">
          <p>{{ inputItem.getFormattedNumber(measuredValue) }}</p>
        </div>
      </div>
      <br/>
      <div>
        <div >
          <p class="cp-info-labels">{{ endLegend }}</p>
        </div>
        <div>
          <p>{{ inputItem.getFormattedNumber(amountValue) }}</p>
        </div>
      </div>
    </div>

</cp-widget>


